import { render, staticRenderFns } from "./guidedTour.vue?vue&type=template&id=bb2cea18&scoped=true&"
import script from "./guidedTour.vue?vue&type=script&lang=js&"
export * from "./guidedTour.vue?vue&type=script&lang=js&"
import style0 from "./guidedTour.vue?vue&type=style&index=0&id=bb2cea18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2cea18",
  null
  
)

export default component.exports